import React, { useState } from 'react';
import { Box, Typography, Paper, Checkbox, FormControlLabel, Alert, Divider } from '@mui/material';
import StyledButton from '../../common/StyledButton';
import StyledTextField from '../../common/StyledTextField';

const HandmadeAgreementStep = ({ onNext, onBack, initialData = {} }) => {
  const [checked, setChecked] = useState(!!initialData.handmadeAgreementAccepted);
  const [signature, setSignature] = useState(initialData.vendorAgreementSignature || '');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (!checked) {
      setError('You must agree to the handmade-only policy to continue.');
      return;
    }
    if (!signature.trim()) {
      setError('Please provide your digital signature to continue.');
      return;
    }
    onNext({ 
      handmadeAgreementAccepted: true,
      vendorAgreementSignature: signature.trim()
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: '#fafbfc' }}>
        <Typography variant="h6" gutterBottom>
          Vendor Agreement: Handmade Goods Only
        </Typography>
        <Typography variant="body2" paragraph>
          By checking this box, I confirm that:
        </Typography>
        <ul>
          <li>All products I plan to sell at the market are handmade, handcrafted, or personally designed by me or my team.</li>
          <li>I understand that mass-produced, third-party, or wholesale items are not allowed at this event.</li>
          <li>I agree that if I am found selling non-handmade items, I may be asked to leave the market without refund.</li>
          <li>I am committed to maintaining the spirit of this market by showcasing and honoring artisan craftsmanship.</li>
        </ul>
        <FormControlLabel
          control={<Checkbox checked={checked} onChange={e => setChecked(e.target.checked)} color="primary" />}
          label={
            <Typography variant="body1">
              I agree to the handmade-only policy and understand the consequences for non-compliance.
            </Typography>
          }
        />

        <Divider sx={{ my: 3 }} />

        <Alert severity="error" sx={{ mb: 3, border: '2px solid #d32f2f' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
            🚫 NO REFUNDS POLICY
          </Typography>
          <Typography variant="body2">
            <strong>All booth payments are FINAL and NON-REFUNDABLE.</strong> By proceeding with registration, you acknowledge and agree that no refunds will be issued under any circumstances, including weather conditions, personal emergencies, or changes in plans. Please ensure you are fully committed to participating before completing your registration.
          </Typography>
        </Alert>

        <Typography variant="h6" gutterBottom>
          Legal Disclaimer and Agreement
        </Typography>
        <Typography variant="body2" paragraph sx={{ mb: 3 }}>
          The undersigned hereby accepts the responsibility to see that all occupants of the booth abide by the rules and regulations as set forth above and to have the display in place and occupied for complete hours of the show. The undersigned does hereby and forever discharge the LUCEDALE FINE ARTS CLUB and GEORGE COUNTY FAIRGROUNDS from all manner of actions, suits, damages, claims, and demands whatsoever in law and equity from loss or damage to the undersigned's property while on site, possession, supervision, or auspices of the above named agents or representatives or employees.
        </Typography>

        <StyledTextField
          fullWidth
          required
          label="Digital Signature (Type your full name)"
          value={signature}
          onChange={(e) => setSignature(e.target.value)}
          placeholder="Type your full name as signature"
          helperText="By typing your full name above, you acknowledge and agree to all terms and conditions stated in this agreement."
          sx={{ mt: 2 }}
        />
      </Paper>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
      )}
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
        <StyledButton onClick={onBack} variant="outlined">
          Back
        </StyledButton>
        <StyledButton type="submit" variant="contained" disabled={!checked || !signature.trim()}>
          Next
        </StyledButton>
      </Box>
    </Box>
  );
};

export default HandmadeAgreementStep; 